import { Action } from '@ngrx/store';

import * as authActions from '@auth/store/auth.actions';
import * as inventoryActions from '@inventory/store/inventory.actions';
import * as orderActions from '@orders/store/orders.actions';

import type { AnywhereReportsList } from '@types';

export const INV_SUM_SET_GRID_DATA = '[INV_SUM] - Store Grid Data';
export const INV_SUM_CLEAR_GRID_DATA = '[INV_SUM] - Clear Grid Data';
export const INV_DTL_SET_GRID_DATA = '[INV_DTL] - Store Grid Data';
export const INV_DTL_CLEAR_GRID_DATA = '[INV_DTL] - Clear Grid Data';
export const INV_LOT_SET_GRID_DATA = '[INV_LOT] - Store Grid Data';
export const INV_LOT_CLEAR_GRID_DATA = '[INV_LOT] - Clear Grid Data';
export const ORD_INQ_SET_GRID_DATA = '[ORD INQ] - Store Grid Data';
export const ORD_INQ_CLEAR_GRID_DATA = '[ORD INQ] - Clear Grid Data';
export const ORD_DTL_SET_GRID_DATA = '[ORD DTL] - Store Grid Data';
export const ORD_DTL_CLEAR_GRID_DATA = '[ORD DTL] - Clear Grid Data';
export const ORD_MOD_HDR_SET_DATA = '[ORD MOD HDR] - Store Data';
export const ORD_MOD_HDR_CLEAR_DATA = '[ORD MOD HDR] - Clear Data';
export const ORD_MOD_DTL_SET_GRID_DATA = '[ORD MOD DTL] - Store Grid Data';
export const ORD_MOD_DTL_CLEAR_GRID_DATA = '[ORD MOD DTL] - Clear Grid Data';
export const USER_LOOKUP_SET_GRID_DATA = '[USER LOOKUP] - Store Grid Data';
export const USER_LOOKUP_CLEAR_GRID_DATA = '[USER LOOKUP] - Clear Grid Data';
export const USER_DETAIL_LOOKUP_SET_DATA = '[USER DETAIL LOOKUP] - Store Data';
export const USER_DETAIL_LOOKUP_CLEAR_DATA = '[USER DETAIL LOOKUP] - Clear Data';
export const REPORT_LIST_SET_GRID_DATA = '[REPORT LIST] - Store Grid Data';
export const REPORT_LIST_CLEAR_GRID_DATA = '[REPORT LIST] - Clear Grid Data';

export class InvSumSetGridData implements Action {
  readonly type = INV_SUM_SET_GRID_DATA;
  constructor(public rowdata: any[]) {}
}

export class InvSumClearGridData implements Action {
  readonly type = INV_SUM_CLEAR_GRID_DATA;
}

export class InvDtlSetGridData implements Action {
  readonly type = INV_DTL_SET_GRID_DATA;
  constructor(public rowdata: any[]) {}
}

export class InvDtlClearGridData implements Action {
  readonly type = INV_DTL_CLEAR_GRID_DATA;
}

export class InvLotSetGridData implements Action {
  readonly type = INV_LOT_SET_GRID_DATA;
  constructor(public rowdata: any[]) {}
}

export class InvLotClearGridData implements Action {
  readonly type = INV_LOT_CLEAR_GRID_DATA;
}

export class OrdInqSetGridData implements Action {
  readonly type = ORD_INQ_SET_GRID_DATA;
  constructor(public rowdata: any[]) {}
}

export class OrdDtlClearGridData implements Action {
  readonly type = ORD_DTL_CLEAR_GRID_DATA;
}

export class OrdDtlSetGridData implements Action {
  readonly type = ORD_DTL_SET_GRID_DATA;
  constructor(public rowdata: any[]) {}
}

export class OrdModHdrClearData implements Action {
  readonly type = ORD_MOD_HDR_CLEAR_DATA;
}

export class OrdModHdrSetData implements Action {
  readonly type = ORD_MOD_HDR_SET_DATA;
  constructor(public data: any) {}
}

export class OrdModDtlClearGridData implements Action {
  readonly type = ORD_MOD_DTL_CLEAR_GRID_DATA;
}

export class OrdModDtlSetGridData implements Action {
  readonly type = ORD_MOD_DTL_SET_GRID_DATA;
  constructor(public rowdata: any[]) {}
}

export class OrdInqClearGridData implements Action {
  readonly type = ORD_INQ_CLEAR_GRID_DATA;
}

export class UserLookupSetGridData implements Action {
  readonly type = USER_LOOKUP_SET_GRID_DATA;
  constructor(public rowdata: any[]) {}
}

export class UserLookupClearGridData implements Action {
  readonly type = USER_LOOKUP_CLEAR_GRID_DATA;
}

export class UserDetailLookupSetData implements Action {
  readonly type = USER_DETAIL_LOOKUP_SET_DATA;
  constructor(public rowdata: any[]) {}
}

export class UserDetailLookupClearData implements Action {
  readonly type = USER_DETAIL_LOOKUP_CLEAR_DATA;
}

export class ReportListSetGridData implements Action {
  readonly type = REPORT_LIST_SET_GRID_DATA;
  constructor(public reports: AnywhereReportsList[]) {}
}

export class ReportListClearGridData implements Action {
  readonly type = REPORT_LIST_CLEAR_GRID_DATA;
}

export type TempDataActions =
  | InvSumSetGridData
  | InvSumClearGridData
  | InvDtlSetGridData
  | InvDtlClearGridData
  | InvLotSetGridData
  | InvLotClearGridData
  | OrdInqSetGridData
  | OrdInqClearGridData
  | UserLookupSetGridData
  | UserLookupClearGridData
  | UserDetailLookupSetData
  | UserDetailLookupClearData
  | ReportListSetGridData
  | ReportListClearGridData
  | OrdDtlSetGridData
  | OrdDtlClearGridData
  | OrdModDtlSetGridData
  | OrdModDtlClearGridData
  | authActions.ChangeFacility
  | authActions.ChangeCustomer
  | OrdModHdrClearData
  | OrdModHdrSetData
  | inventoryActions.InvSumInit
  | inventoryActions.InvSumClearSelectedRow
  | inventoryActions.InvDtlInit
  | inventoryActions.InvDtlClearSelectedRow
  | orderActions.OrdInqInit
  | orderActions.OrdInqReinit
  | orderActions.OrdInqClearSelectedRow
  | orderActions.OrdInqRequestData
  | orderActions.OrdModHdrCreateInit
  | orderActions.OrdModHdrCreateInboundSuccess
  | orderActions.OrdModHdrCreateOutboundSuccess;
